import { useEffect, useState } from 'react'
import { Row, Col, Container, Dropdown } from 'react-bootstrap'
import { Link, useLocation, useParams } from 'react-router-dom'
import Card from '../../components/Card'
import CustomToggle from '../../components/dropdowns'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"
//image
import user01 from '../../assets/images/user/01.jpg'
import user2 from '../../assets/images/user/02.jpg'
import s1 from '../../assets/images/page-img/s1.jpg'
import s2 from '../../assets/images/page-img/s2.jpg'
import s3 from '../../assets/images/page-img/s3.jpg'
import s4 from '../../assets/images/page-img/s4.jpg'
import s5 from '../../assets/images/page-img/s5.jpg'
import img42 from '../../assets/images/page-img/42.png'
import img9 from '../../assets/images/small/img-1.jpg'
import img10 from '../../assets/images/small/img-2.jpg'
import loader from '../../assets/images/page-img/page-load-loader.gif'
import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast';
import { getToken } from '../../utils/auth'
import { useNavigate } from 'react-router-dom'
import { Pagination } from '@mui/material'
import LostCard from './LostCard'
import useAuth from '../../utils/useAuth'
import Sponsored from '../dashboard/Sponsored'
import moment from "moment";

const LostFoundList = () => {
    useAuth();
    const navigate = useNavigate();
    const params = useParams();
    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);

    const [lostDevices, setLostDevices] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const handleGetLostDevices = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/device/lost/all?page=${page}&limit=5&searchFor=${params?.key}`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            )
            setLostDevices(response?.data?.data);
            setHasMore(response?.data?.data?.deviceList?.length > 0);
        } catch (error) {
            console.log("Failed Fetching Devices", error);
        }
    }
    useEffect(() => {
        handleGetLostDevices();
        handleUpcoming();
    }, [])
    const [upcoming, setUpcoming] = useState([]);
    const handleUpcoming = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/event/upcoming/all`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "Content-Type": "multipart/form-data"
                    },
                }
            );

            setUpcoming(response.data.data.allEvents);
        } catch (error) {
            console.log("Failed Fetching Upcoming Event", error);
        }
    };
    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
<div id="content-page" className="content-page">
                <Container>
                    <Row>
                        <Col lg={8} className="row m-0 p-0 ">
                            <LostCard
                                lostDevices={lostDevices?.deviceList}
                                page={page}
                                setPage={setPage}
                                hasMore={hasMore} />

                        </Col>
                        <Col lg={4}>
                            <Sponsored />
                            <Card>
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">Upcoming Events</h4>
                                    </div>

                                </div>
                                <Card.Body>
                                    <ul className="media-story list-inline m-0 p-0">
                                        {upcoming?.length === 0 ? (
                                            <li className="d-flex mb-4 align-items-center">
                                                <div className="stories-data ms-3">
                                                    <h5
                                                        className="mb-1"
                                                        style={{ fontWeight: "bold", color: "gray" }}
                                                    >
                                                        No upcoming events
                                                    </h5>
                                                </div>
                                            </li>
                                        ) : (
                                            upcoming.map((data, index) => (
                                                <li
                                                    key={index}
                                                    className="d-flex mb-4 align-items-center"
                                                >
                                                    <img
                                                        src={s5}
                                                        alt="story1"
                                                        className="rounded-circle img-fluid"
                                                        style={{ width: "50px", height: "50px" }}
                                                    />
                                                    <div className="stories-data ms-3">
                                                        <h5
                                                            className="mb-1"
                                                            style={{
                                                                fontWeight: "bold",
                                                                textTransform: "capitalize",
                                                            }}
                                                        >
                                                            {data?.title}
                                                        </h5>
                                                        <p className="mb-0">
                                                            {moment(data?.startDate).format(
                                                                "MMMM Do YYYY, h:mm a"
                                                            )}
                                                        </p>
                                                        <p className="mb-0">
                                                            Organized by: {data?.userId?.firstName}{" "}
                                                            {data?.userId?.lastName}
                                                        </p>
                                                    </div>
                                                </li>
                                            ))
                                        )}
                                    </ul>
                                </Card.Body>
                            </Card>

                        </Col>
                        <div className="col-sm-12 text-center">
                            <img src={loader} alt="loader" style={{ height: "100px" }} />
                        </div>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default LostFoundList
